// tslint:disable: triple-equals
import React from 'react';
import { Pill } from './../../../common/sharedComponents/Pill';
import { SquareSection, SquareContainer, VerticalLine } from './styled.score';
import { IScoreValues } from './../../../@types/pill';

export function Score ({ scoreList }: { scoreList: IScoreValues[] }) {
  return (
    <SquareSection>
      {scoreList &&
        scoreList.map((itemPill, index) =>
          itemPill.key === 'Score' ? (
            <SquareContainer
              key={index}
              backgroundColor={itemPill.backgroundColor}
            >
              <Pill value={itemPill.value} keyValue={itemPill.keyValue} />
            </SquareContainer>
          ) : null
        )}
      <VerticalLine />
      {scoreList &&
        scoreList.map((itemPill, index) =>
          itemPill.key != 'Score' ? (
            <SquareContainer
              key={index}
              backgroundColor={itemPill.backgroundColor}
            >
              <Pill value={itemPill.value} keyValue={itemPill.keyValue} />
            </SquareContainer>
          ) : null
        )}
    </SquareSection>
  );
}
